{
  "colorSwatchPicker": "Spalvų pavyzdžiai",
  "dropzoneLabel": "„DropZone“",
  "selectPlaceholder": "Pasirinkite elementą",
  "tableResizer": "Dydžio keitiklis"
}
